import type {FormController} from '../forms/types';

export function ariaInvalid(node: HTMLElement, formController: FormController<unknown>) {

    const subscription = formController.getFieldState$()
        .subscribe((fieldState) => {
            node.setAttribute('aria-invalid', fieldState.invalid.toString());
        });

    return {
        destroy: () => subscription.unsubscribe()
    };
}